// @flow

import React, { type Node as ReactNode } from 'react'
import { connect } from 'react-redux'
import { checkValidity } from '../../utils/validations.js/validation'

import ErrorMessage from '../ErrorMessage/ErrorMessage'
import SortBar from '../SortBar/SortBar'

import { MainRows } from './Rows/MainRows/index'
import { TopRows } from './Rows/TopRows/index'

import styles from './Main.css'

type BarListProps = {
  data: Array<Object>,
  total: Object,
  length: number,
  selected: Object,
  textMaxLength: number,
  highestNumber: number,
  fields: Array<Object>,
  type: string,
  hasError: ?boolean,
  error: string,
  isNotInitialMount: boolean
}

const Main = (props: BarListProps): ReactNode => {
  const {
    data,
    total,
    selected,
    textMaxLength,
    highestNumber,
    fields,
    type,
    hasError,
    error
  } = props

  if (!data.length) {
    return null
  }
  if (!checkValidity(type, fields)) {
    return (
      <div>
        <table className={styles.main}>
          <tbody>
            <ErrorMessage
              hasError={true}
              severe
              error={{
                message: 'Feil i validering av datasett opp i mot visningstype'
              }}
            />
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <div>
      <TopRows
        selectedData={selected}
        totalData={total}
        textMaxLength={textMaxLength}
        highestNumber={highestNumber}
        selected={selected}
        fields={fields}
        type={type}
        caption="Tabell en av to"
      />

      <SortBar text="Sammenlignet med" />
      <ErrorMessage hasError={Boolean(hasError)} error={{ message: error }} />

      <MainRows
        data={data}
        textMaxLength={textMaxLength}
        highestNumber={highestNumber}
        fields={fields}
        type={type}
        caption={selected || total ? 'Tabell to av to' : 'Tabell en av en'}
      />
    </div>
  )
}

Main.defaultProps = {
  selected: null,
  data: [],
  total: {},
  length: 3,
  textMaxLength: 0,
  highestNumber: 0,
  isNotInitialMount: false
}

const mapStateToProps = ({ search, dataset, parameters }): Object => {
  return {
    selected: search.selected,
    data: dataset.showingData,
    highest: dataset.rootData[0],
    total: dataset.total,
    textMaxLength: parameters.textMaxLength,
    fields: parameters.fields,
    highestNumber: parameters.highestNumber,
    isFetching: dataset.isFetching,
    hasError: dataset.hasError,
    error: dataset.error,
    type: parameters.type,
    isNotInitialMount: parameters.isNotInitialMount
  }
}

export default connect(mapStateToProps)(Main)



// WEBPACK FOOTER //
// ./src/shared/components/Main/Main.js